<div class="header-container m-t-50"></div>
<app-dialog-heading [heading]="'Update Payment Reference'"></app-dialog-heading>

<div>
  <form>
    <mat-grid-list cols="1" rowHeight="75px">

      <mat-grid-tile>
        <app-content-field [label]="'Payment ID'" [content]="paymentDTO.paymentId"></app-content-field>
      </mat-grid-tile>

      <mat-grid-tile>
        <mat-form-field class="width-66">
          <mat-label>Payment Reference</mat-label>
          <input type="text" matInput [formControl]="paymentReferenceFormControl" required>
        </mat-form-field>
        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Payment Reference')">help_outline</mat-icon>
      </mat-grid-tile>

      <mat-grid-tile>
        <mat-form-field class="width-66">
          <mat-label>Payment Completion Date</mat-label>
          <input [formControl]="completionDateFormControl" [min]="paymentExecutionDate" [matDatepicker]="completionDatePicker" matInput required>
          <mat-datepicker-toggle [for]="completionDatePicker" matIconSuffix>
          </mat-datepicker-toggle>
          <mat-datepicker #completionDatePicker></mat-datepicker>
        </mat-form-field>
        <mat-icon [matTooltip]="getInfoTooltip('Payment Completion Date')" class="info-icon">help_outline</mat-icon>
      </mat-grid-tile>
      
    </mat-grid-list>

    <div class="dialog-button-container">
      <button class="margin-15-px button-width" mat-raised-button color="warn"
              (click)="onCancelClick()">Cancel</button>
      <button class="button-width" mat-raised-button color="primary"
              [disabled]="isSaveDisabled()" (click)="savePaymentReference()">Save
        <mat-icon *ngIf="!isAuthorised" class="info-icon" matTooltip="Only the financial team can edit payments">help_outline</mat-icon>                                                                                                                                                                                                                                                                                                                                                                        
      </button>
    </div>

  </form>
</div>
